const CREATE_TPOS_ORDER = "CREATE_TPOS_ORDER";
const HIDE_PLACED_ORDER_MODAL = "HIDE_PLACED_ORDER_MODAL";
const COPY_OPTIONS = "COPY_OPTIONS";
const COPY_LINE_OPTIONS = "COPY_LINE_OPTIONS";
const MODIFY_OPTIONS = "MODIFY_OPTIONS";
const UPDATE_OPTION_FOR_LINE = "UPDATE_OPTION_FOR_LINE";
const DELETE_SAVED_LINE_OPTIONS = "DELETE_SAVED_LINE_OPTIONS";
const DELETE_OPTION_LINE = "DELETE_OPTION_LINE";
const CLEANUP_BY_LINE = "CLEANUP_BY_LINE";

const UPDATE_ALL_OPTIONS_ASYNC = "UPDATE_ALL_OPTIONS_ASYNC";
const UPDATE_INDIVIDUAL_OPTIONS_ASYNC = "UPDATE_INDIVIDUAL_OPTIONS_ASYNC";
const CLEANUP_ASYNC = "CLEANUP_ASYNC";
const DELETE_LINE_OPTIONS_ASYNC = "DELETE_LINE_OPTIONS_ASYNC";
const REVERT_CHILD_LINES_ASYNC = "REVERT_CHILD_LINES_ASYNC";
const DELETE_OPTION_LINE_ASYNC = "DELETE_OPTION_LINE_ASYNC";
const DELETE_BASKET_ASYNC = "DELETE_BASKET_ASYNC";
const MODIFY_OPTIONS_ASYNC = "MODIFY_OPTIONS_ASYNC";

const ADD_TO_BASKET_ASYNC = "ADD_TO_BASKET_ASYNC";

const SELECT_AGGREGATOR = "SELECT_AGGREGATOR";
const TOGGLE_MODE = "TOGGLE_MODE";
const SET_PRINTER_HOST = "SET_PRINTER_HOST";
const SET_PRINTER_URL = "SET_PRINTER_URL";

const PRINT_RECEIPT_ASYNC = "PRINT_RECEIPT_ASYNC";

const FETCH_PROFILE = "FETCH_PROFILE";

export {
  CREATE_TPOS_ORDER,
  HIDE_PLACED_ORDER_MODAL,
  COPY_OPTIONS,
  COPY_LINE_OPTIONS,
  MODIFY_OPTIONS,
  UPDATE_OPTION_FOR_LINE,
  DELETE_SAVED_LINE_OPTIONS,
  DELETE_OPTION_LINE,
  CLEANUP_BY_LINE,
  UPDATE_ALL_OPTIONS_ASYNC,
  UPDATE_INDIVIDUAL_OPTIONS_ASYNC,
  CLEANUP_ASYNC,
  DELETE_LINE_OPTIONS_ASYNC,
  REVERT_CHILD_LINES_ASYNC,
  DELETE_OPTION_LINE_ASYNC,
  DELETE_BASKET_ASYNC,
  ADD_TO_BASKET_ASYNC,
  MODIFY_OPTIONS_ASYNC,
  SELECT_AGGREGATOR,
  TOGGLE_MODE,
  SET_PRINTER_HOST,
  SET_PRINTER_URL,
  PRINT_RECEIPT_ASYNC,
  FETCH_PROFILE,
};
